import view from '../../view';
import site from '../../site';
import linkTypes from '../constants/link-types';
import defaultConfig from '../constants/default-config';
import isHomePage from '../../site/verifiers/is-home-page';
import isURL from '../../../utils/validation/is-url';
import forceHTTPS from '../../../utils/force-https';

const getFallbackConfig = (element) => {
  let href = element.getAttribute('href');

  if (!href) return defaultConfig;

  if (element.hasAttribute('download')) {
    return {
      linkType: linkTypes.DOWNLOAD,
      reference: href,
      download: element.getAttribute('download'),
    };
  }

  if (href.includes('tel:')) {
    return {
      linkType: linkTypes.PHONE,
      reference: href.replace('tel:', ''),
    };
  }

  if (href.includes('mailto:')) {
    return {
      linkType: linkTypes.MAIL,
      reference: href.replace('mailto:', ''),
    };
  }

  const liveDocument = view.accessors.getLiveDocument();
  let baseHref = null;

  if (liveDocument) {
    baseHref = liveDocument.querySelector('base').href;
  }

  if (isURL(href)) {
    if (baseHref && href.includes(baseHref)) {
      href = href.replace(baseHref, '');
    } else {
      return {
        linkType: linkTypes.EXTERNAL,
        reference: forceHTTPS(href),
      };
    }
  }

  if (href === '#') return defaultConfig;

  const activePage = site.accessors.getActivePage();

  if (href.includes('#')) {
    const pageBlocks = view.accessors.getPageBlocks();
    const blockId = href.split('#')[1];

    if (blockId.length) {
      const filteredBlockOption = pageBlocks
        .filter((block) => !block.id.startsWith('widget-'))
        .find((block) => block.id === blockId);
      if (filteredBlockOption) {
        return {
          linkType: linkTypes.ANCHOR,
          reference: blockId,
          pageId: activePage.id,
        };
      }
    }

    return {
      linkType: linkTypes.EXTERNAL,
      reference: href,
    };
  }

  const pages = site.accessors.getPages();

  const matchedPage = pages.find((page) => page.path === href);

  if (matchedPage) {
    if (isHomePage(matchedPage.path)) {
      const result = {
        linkType: linkTypes.PATH,
        reference: href,
      };

      if (activePage.locale !== matchedPage.locale) {
        result.locale = matchedPage.locale;
      }

      return result;
    }

    return {
      linkType: linkTypes.PAGE,
      reference: matchedPage.id,
    };
  }

  return {
    linkType: linkTypes.PATH,
    reference: href,
  };
};

export default getFallbackConfig;
